/**
 * Convenience type guard for response from `Broadcaster.broadcast`
 */
export function isBroadcastResponse(r) {
    return r.status === 'success';
}
/**
 * Convenience type guard for response from `Broadcaster.broadcast`
 */
export function isBroadcastFailure(r) {
    return r.status === 'error';
}
//# sourceMappingURL=Broadcaster.js.map